// Foreva Jewels product info cards (blocks/fj-info-cards.liquid, blocks/_fj-info-card.liquid).
//
// One card open at a time: the cards share a `name`, so the browser closes the others natively; a small
// fallback does the same where `name` isn't supported. Opening a card below an open one would make the
// page jump as the upper card collapses, so the tapped heading is held in place while that happens. If
// the opened heading then sits low on the screen, it eases up to just under the sticky header.

const HOLD_MS = 450;
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
const nativeExclusive = 'name' in HTMLDetailsElement.prototype;

/** @returns {number} */
function headerOffset() {
  const value = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
  return (Number.isFinite(value) ? value : 60) + 12;
}

/** @param {HTMLElement} summary */
function holdInPlace(summary) {
  const startTop = summary.getBoundingClientRect().top;
  const start = performance.now();

  const step = (now) => {
    const drift = summary.getBoundingClientRect().top - startTop;
    if (Math.abs(drift) > 0.5) window.scrollBy({ top: drift, behavior: 'instant' });
    if (now - start < HOLD_MS) {
      requestAnimationFrame(step);
      return;
    }

    const details = summary.parentElement;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    const top = summary.getBoundingClientRect().top;
    const offset = headerOffset();
    // Bring a heading that is hidden under the header, or low on the screen, to a comfortable reading spot.
    if (top < offset || top > window.innerHeight * 0.55) {
      window.scrollBy({ top: top - offset, behavior: reduceMotion ? 'instant' : 'smooth' });
    }
  };
  requestAnimationFrame(step);
}

document.addEventListener('click', (event) => {
  const summary = event.target instanceof Element ? event.target.closest('.fjic__head') : null;
  if (!(summary instanceof HTMLElement)) return;
  const details = summary.parentElement;
  if (!(details instanceof HTMLDetailsElement)) return;

  if (!nativeExclusive && !details.open && details.name) {
    document.querySelectorAll(`details.fjic[name="${CSS.escape(details.name)}"][open]`).forEach((other) => {
      if (other !== details && other instanceof HTMLDetailsElement) other.open = false;
    });
  }
  holdInPlace(summary);
});
